module.exports = __webpack_public_path__ + "static/media/比赛6.b926ee87.png";